/**
 * サーバーから取得したデータをテンプレートリテラルでHTML文字列に組み立て
 * innerHTML/insertAdjacentHTMLへ差し込む一覧・プレビュー画面向けの共通エスケープ関数。
 *
 * 属性値コンテキスト（例: title="${escapeHtml(value)}"）でも安全に使えるよう、
 * シングルクォートもエスケープ対象に含めている。
 */
export function escapeHtml(value) {
    if (value === null || value === undefined) return '';
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
